import React, { useContext } from 'react';
import { PromiseState } from 'react-refetch';

import connect from 'helpers/apiConnect';

import getSocialKPIURL from 'url-constructors/getSocialKPIURL';
import getSocialTopPostsURL from 'url-constructors/getSocialTopPostsURL';
import getEntityMetadataByIdsURL from 'url-constructors/getEntityMetadataByIdsURL';

import SocialTable from 'components/data-containers/Overview/SocialPerformance/SocialTable';
import { Grid } from 'components/Overview/Container/shared.style';
import OverviewContainer from 'components/Overview/Container/Container';
import TopSocialPost from './TopSocialPost';

import useUrlForTopic from 'components/data-containers/Overview/shared/utils/useUrlForTopic';
import metrics from 'maps/metrics';
import { EntityContext } from 'context/entityContext';
import { TimeFrames } from 'components/TopicFilters/shared';

function dataSources(props: any): any {
  const { artistIds } = props;

  if (!artistIds) return {};

  return {
    socialPerformanceFetch: getSocialKPIURL({ ...props, entityIds: artistIds }),
    artistMetaData: {
      method: 'POST',
      url: getEntityMetadataByIdsURL({ entityType: 'artist' }),
      body: JSON.stringify(artistIds),
    },
    socialTopPostsData: getSocialTopPostsURL({
      entityIds: artistIds,
    }),
  };
}

function getLocalSortBy(globalSortBy: TimeFrames): string {
  switch (globalSortBy) {
    case 'lw':
      return 'countLastWeek';
    case 'twtd':
    default:
      return 'countThisWeekToDate';
  }
}

interface ISocialPerformanceProps {
  socialPerformanceFetch: PromiseState<any>;
  artistMetaData: PromiseState<any>;
  socialTopPostsData: PromiseState<any>;
}

/*
 * The social performance card on overview doesn't accept filters and consists of:
 * - Social table — showing gained followers/likes and total.
 * - Top post — top post of total engagement across platforms from last 30 days.
 *
 *  This card shows up for all entity types and has no variants, it always shows
 *  artist data.
 */
const SocialPerformance: React.FC<ISocialPerformanceProps> = (props) => {
  const {
    socialPerformanceFetch = PromiseState.create(),
    artistMetaData = PromiseState.create(),
    socialTopPostsData = PromiseState.create(),
  } = props;

  const ctx = useContext(EntityContext);
  const { viewSettings } = ctx;

  const timeframe = viewSettings?.timeframe || 'twtd';

  const sortByValue = getLocalSortBy(timeframe);
  const sortByMetric = metrics[sortByValue];

  return (
    <OverviewContainer
      title="Social Performance"
      linkTo={useUrlForTopic('social')}
    >
      <Grid>
        <SocialTable
          sortMetric={sortByMetric}
          headers={[sortByMetric.label, 'total followers']}
          socialData={socialPerformanceFetch.value}
          isPending={socialPerformanceFetch.pending}
        />
        <TopSocialPost
          artistMetaData={artistMetaData.value}
          topPosts={socialTopPostsData.value}
        />
      </Grid>
    </OverviewContainer>
  );
};

export default connect(dataSources)(SocialPerformance);
